// The Blackwater Society — tema Shopify

document.addEventListener("DOMContentLoaded", () => {

  // menú móvil
  const toggle = document.querySelector(".nav-toggle");
  const nav = document.querySelector(".main-nav");
  if (toggle && nav) {
    toggle.addEventListener("click", () => {
      const open = nav.classList.toggle("open");
      toggle.setAttribute("aria-expanded", open ? "true" : "false");
    });
  }

  // galería de producto
  document.querySelectorAll(".thumbs button").forEach((btn) => {
    btn.addEventListener("click", () => {
      document.querySelectorAll(".thumbs button").forEach((b) => b.classList.remove("active"));
      btn.classList.add("active");
      const img = document.getElementById("mainImg");
      if (img) img.src = btn.dataset.img;
    });
  });

  // selector de variantes (talla / color) conectado al precio y a la imagen
  const jsonEl = document.querySelector("[data-product-variants]");
  const variantInput = document.querySelector(".variant-id-input");
  const priceEl = document.getElementById("productPrice");
  const addBtn = document.getElementById("addToCartBtn");
  const selects = document.querySelectorAll(".option-select");

  if (jsonEl && selects.length) {
    let variants = [];
    try { variants = JSON.parse(jsonEl.textContent); } catch (e) { variants = []; }

    function formatMoney(cents) {
      return (cents / 100).toLocaleString("es-ES", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " €";
    }

    function updateVariant() {
      const chosen = Array.from(selects).map((s) => s.value);
      const match = variants.find((v) => {
        const opts = [v.option1, v.option2, v.option3].filter((o) => o !== null && o !== undefined);
        return chosen.every((val, i) => opts[i] === val);
      });

      if (!match) return;

      if (variantInput) variantInput.value = match.id;
      if (priceEl) priceEl.textContent = formatMoney(match.price);

      if (addBtn) {
        if (match.available) {
          addBtn.removeAttribute("disabled");
          addBtn.textContent = "Añadir al carrito";
        } else {
          addBtn.setAttribute("disabled", "disabled");
          addBtn.textContent = "Agotado";
        }
      }

      if (match.featured_image && document.getElementById("mainImg")) {
        document.getElementById("mainImg").src = match.featured_image.src;
      }
    }

    selects.forEach((s) => s.addEventListener("change", updateVariant));
  }
});
